// extracted by mini-css-extract-plugin
export default {"text":"fYqU6u","disabled":"is_M1l"};